"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Footer = exports.Child = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var Child = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Child",
  componentId: "sc-1k2h6j6-0"
})(["margin:", ";"], _tokens["default"].spaceSm);

exports.Child = Child;

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-1k2h6j6-1"
})(["align-items:center;background-color:", ";display:flex;flex-wrap:wrap;justify-content:flex-end;padding:", ";"], _tokens["default"].modal.footer.backgroundColor, _tokens["default"].spaceLg);

exports.Footer = Footer;
//# sourceMappingURL=Footer.styles.js.map